import { Spin } from "antd";
import React from "react";
import "./index.scss";
export var Spinner = function Spinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: "spinner-container"
  }, /*#__PURE__*/React.createElement(Spin, null));
};